import { useState, type FormEvent } from "react";
import { useAuth } from "../auth/AuthContext";

type Mode = "login" | "signup";

export function LoginView() {
  const { login, signup } = useAuth();
  const [mode, setMode] = useState<Mode>("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      if (mode === "signup") {
        await signup(email, password, displayName.trim() || undefined);
      } else {
        await login(email, password);
      }
    } catch (ex) {
      setErr((ex as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-card">
        <h1>
          Pix Studio Online <span className="auth-card-sub">{mode === "signup" ? "アカウント作成" : "ログイン"}</span>
        </h1>

        <form onSubmit={submit}>
          {mode === "signup" && (
            <label>
              表示名
              <input
                type="text"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                placeholder="あきも"
                autoComplete="nickname"
              />
            </label>
          )}
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </label>
          <label>
            Password
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete={mode === "signup" ? "new-password" : "current-password"}
              minLength={8}
            />
            {mode === "signup" && <small>8 文字以上</small>}
          </label>

          {err && <div className="auth-error">{err}</div>}

          <button className="btn btn-primary" type="submit" disabled={busy}>
            {busy ? "..." : mode === "signup" ? "サインアップ" : "ログイン"}
          </button>
        </form>

        <div className="auth-switch">
          {mode === "login" ? (
            <span>
              アカウントを持っていない?{" "}
              <button className="link-btn" onClick={() => setMode("signup")}>
                作成する
              </button>
            </span>
          ) : (
            <span>
              既にアカウントがある?{" "}
              <button className="link-btn" onClick={() => setMode("login")}>
                ログイン
              </button>
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
